import { createDiagnosticFileName } from '@patsnap/synapse_common_utils'
import { downloadBlob } from 'pharmsnapMF_shared/utils'

export { createDiagnosticFileName }

export async function downloadDiagnosticReport(): Promise<void> {
  const { createCurrentDiagnosticReport } = await import('./index')
  const report = await createCurrentDiagnosticReport()
  const blob = new Blob([JSON.stringify(report, null, 2)], {
    type: 'application/json;charset=utf-8',
  })
  downloadBlob(blob, createDiagnosticFileName(report.generatedAt))
}
